import { BaseUtilities } from '@core/shared/BaseUtilities';
export class Utilities extends BaseUtilities {
    constructor() {
        super();
    }
    static isValidUrl(url) {
        try {
            new URL(url);
            return true;
        }
        catch (_) {
            return false;
        }
    }
}
